import { last } from "lodash-es";
import { useMatches } from "react-router-dom";
import { RouteIds } from "shared/navigation/Routes";

export const useCurrentPageTabId = () => {
  const matches = useMatches();
  return last(matches)?.id as (typeof RouteIds)[number];
};
